import { IJsonQueryTerm } from './term';

export enum ESearchType {
  /** Бонусы **/
  Bonus = 'bonus',
  /** Циан ипотека **/
  CianMortgage = 'cianMortgage',
  /** Скидки **/
  Discount = 'discount',
  /** Скидки и акции от застройщиков **/
  FromBuilder = 'fromBuilder',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Военная ипотека **/
  Military = 'military',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Ипотека от банка **/
  MortgageFromBank = 'mortgageFromBank',
  /** Ипотека от застройщиков **/
  MortgageFromBuilder = 'mortgageFromBuilder',
}

export type IJsonQuerySearchType = IJsonQueryTerm<ESearchType>;
